import React from 'react';
import { DatePicker, Checkbox, Select } from 'antd';
import { toast } from 'react-toastify';
import services from '../../services';
import { withRouter } from 'react-router-dom';
import FormleftNev from '../common/FormleftNev';
import EntityFilter from '../common/EntityFilter'
import queryString, { parse } from 'query-string'
import FormNavbar from '../common/wizard_navbar';
import Lang from '../../lang'
import { Input, TextArea } from '@progress/kendo-react-inputs';
import $ from "jquery";
import { TreeSelect } from 'antd';
import 'antd/dist/antd.css';
import { string } from 'prop-types';
const moment = require('moment');
var idForm = null;
const { Option } = Select
const InputFieldsAll = {
    GestaoRS: [
        {
            key: "FinalidadeRS",
            type: "multiselect",
            display: "FinalidadeRS"
        },
        {
            key: "NomeCampoRS",
            type: "multiselect",
            display: "NomeCampoRS"
        },
        {
            key: "ObrigatorioCampoRS",
            type: "checkbox",
            display: "ObrigatorioCampoRS"
        },
        
        {
            key: "VisivelRS",
            type: "checkbox",
            display: "VisivelRS"
        },
        {
            key: "OrdemRS",
            type: "number",
            display: "OrdemRS"
        },
        {
            key: "EtapaRS",
            type: "multiselect",
            display: "EtapaRS"
        }
    ]
   
}

let apiFilters = {
    Filters: null,
    SortBy: 'ID',
    Page: 1,
    PageSize: 100,
    Filters: null,
    IsSortTypeDESC: false,
    IsPagination: false,
    
};

class NovosCamposRS extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            idMarcaLocalizacao: 0,
            codEstatuto: [],
            codEntidade: 0,
            ruleList: [],
            entityList: [],
            ObrigatorioCampoRS: false,
            VisivelRS: false,
            OrdemRS :'',
            EtapaRS: null,
            error:null,
            isChecked: true,
            ProdutosFrases: [],
            ProdutosSelecionados: null,
            NomeCampoRS: null,
            NomeCampoRSList: [],
            FinalidadeRS: null,
            idCatFinalidade: null,
            idFinalidadeList: [],
            arrayTemas: [],
            selectedValue: null, // Para armazenar o valor selecionado (único)
            expandedKeys: [],
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        let parsed = queryString.parse(window.location.search)
        if(parsed.id){
            this.getEntidadeById(parsed.id)
            var FinalidadeRS = parsed.idFinalidade + "-" + parsed.idCatFinalidade;
            this.setState({ selectedValue: FinalidadeRS }); 
            idForm = parsed.id;
            var idCatFinalidade = parsed.idCatFinalidade;
            this.setState({ FinalidadeRS });
            this.setState({ idCatFinalidade });
        }
        var filter = {};
        (async () => {
            const ProdutosFrases = await services.apiCall.requestApi("RequisicaoServicos/GetEtapasFinalidade", filter, 'get')
            this.setState({ ProdutosFrases });
        })();

        var filter2 = {};
        (async () => {
            const NomeCampoRSList = await services.apiCall.requestApi("RequisicaoServicos/GetAllCamposRS", filter, 'get')
            this.setState({ NomeCampoRSList });
        })();

        var filter3 = {};
        (async () => {
            const data = {};
                const Finalidades = await services.apiCall.requestApi(
                  "/RequisicaoServicos/GetAllFinalidades",
                  data,
                  "get"
                );
            
                if (Finalidades) {
                  const temas = [];
                  Finalidades.forEach((item, index) => {
                    const arraySubTemas = Finalidades.filter(c => c.idCatFinalidade === index + 1);
            
                    if (arraySubTemas.length > 0) {
                      const result = arraySubTemas.map(val => ({
                        label: val.desfinalidade,
                        value: `${val.idFinalidade}-${arraySubTemas[0].idCatFinalidade}`, // ID do subtema
                      }));
            
                      temas.push({
                        label: arraySubTemas[0].descatfinalidade, // Tema (não será selecionado)
                        value: arraySubTemas[0].idCatFinalidade,  // Tema não será selecionado
                        children: result, // Subtemas (que serão selecionáveis)
                      });
                    }
                  });
                  this.setState({ arrayTemas: temas });
                }
        })();
    }

    handleChangeMarcaLocalizacao = (e) => {
        this.setState({ idMarcaLocalizacao: e });
    }
    handleChangeFinalidade = (e) => {
        this.setState({ selectedValue: e });
        var idFinalidade = e.split("-")[0]
        var idCatFinalidade = e.split("-")[1]
        this.setState({ FinalidadeRS: idFinalidade , idCatFinalidade: idCatFinalidade});
    }
    handleChangeNomeCampoRS = (e) => {
        this.setState({ NomeCampoRS: e });
    }
    handleChangeEtapaRS = (e) => {
        this.setState({ EtapaRS: e  , ProdutosSelecionados: e});
    }
    // handleChangeNomeCampoRS = (e) => {
    //     this.setState({ NomeCampoRS: e.value });
    // }
    handleChangeOrdemRS = (e) => {
        this.setState({ OrdemRS: e.value });
    }
    handleChangeTexto = (e) => {
        this.setState({ descricao: e.value });
    }

    handleCheckObrigatorio = (e) => {
        this.setState({ ObrigatorioCampoRS: e.currentTarget.checked });
    }
    handleCheckVisivel = (e) => {
        this.setState({ VisivelRS: e.currentTarget.checked });
    }
      // Função para lidar com a seleção de um único item
  handleSelect = (value) => {
    this.setState({ selectedValue: value });
    console.log("Selecionado:", value);
    // GestaoRSGrid.GetIDFinalidade(value)
  };

  // Controla a expansão das chaves
  onExpand = (expandedKeys) => {
    this.setState({ expandedKeys });
  };
    createInputs(nevkey) {
         const { arrayTemas, selectedValue, expandedKeys } = this.state;
        let inputs = InputFieldsAll[nevkey].map((row, i) => {
            switch (row.type) {
                case "multiselect":
                    if(row.display == "EtapaRS"){
                        return (
                            <React.Fragment key={i}>
                                <p className='LabelGestaoRS'  style={{  marginLeft:"15px" ,marginTop:"10px", marginRight:"15px", marginBottom:"0px" }}>Etapa</p>
                                {this.state.ProdutosSelecionados != null && (
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione a etapa"
                                        className="estatoSelect GestaoListRS"
                                        mode="single"
                                        onChange={(e) => this.handleChangeEtapaRS(e)}
                                        style={{ width: "100%",  marginLeft:"15px" , marginRight:"15px" }}
                                        defaultValue={this.state.ProdutosSelecionados}
                                    >
                                        <Option disabled>Selecione</Option>
                                        {(this.state.ProdutosFrases && !!this.state.ProdutosFrases.length) && this.state.ProdutosFrases.map((item, index) => (
                                            <Option key={index} value={item.codEtapa}>{item.nome}</Option>
                                        ))}
                                    </Select>
                                )}
                                {this.state.ProdutosSelecionados == null && (
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione a etapa"
                                        className="estatoSelect GestaoListRS"
                                        mode="single"
                                        onChange={(e) => this.handleChangeEtapaRS(e)}
                                        style={{ width: "100%",marginLeft:"15px" , marginRight:"15px" }}
                                        //defaultValue={this.state.ProdutosSelecionados}
                                    >
                                        <Option disabled>Selecione</Option>
                                        {(this.state.ProdutosFrases && !!this.state.ProdutosFrases.length) && this.state.ProdutosFrases.map((item, index) => (
                                            <Option key={index} value={item.codEtapa}>{item.nome}</Option>
                                        ))}
                                    </Select>
                                )}
                            </React.Fragment>
                        );
                    }
                    else if(row.display == "NomeCampoRS"){
                        return (
                            <React.Fragment key={i}>
                                <p className='LabelGestaoRS' style={{  marginLeft:"15px" ,marginTop:"10px", marginRight:"15px", marginBottom:"0px" }}>Campo</p>
                                {this.state.NomeCampoRS != null && (
                                    <Select
                                        disabled={idForm != null ? true : false}
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione o nome de campo"
                                        className="estatoSelect GestaoListRS"
                                        mode="single"
                                        onChange={(e) => this.handleChangeNomeCampoRS(e)}
                                        style={{ width: "100%", marginLeft:"15px" , marginRight:"15px" }}
                                        defaultValue={this.state.NomeCampoRS}
                                    >
                                        <Option disabled>Selecione</Option>
                                        {(this.state.NomeCampoRSList && !!this.state.NomeCampoRSList.length) && this.state.NomeCampoRSList.map((item, index) => (
                                            <Option key={index} value={item.idCamposFormulario}>{item.descricao}</Option>
                                        ))}
                                    </Select>
                                )}
                                {this.state.NomeCampoRS == null && (
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione o nome do campo"
                                        className="estatoSelect GestaoListRS"
                                        mode="single"
                                        onChange={(e) => this.handleChangeNomeCampoRS(e)}
                                        style={{ width: "100%", marginLeft:"15px" , marginRight:"15px" }}
                                        //defaultValue={this.state.ProdutosSelecionados}
                                    >
                                        <Option disabled>Selecione</Option>
                                        {(this.state.NomeCampoRSList && !!this.state.NomeCampoRSList.length) && this.state.NomeCampoRSList.map((item, index) => (
                                            <Option key={index} value={item.idCamposFormulario}>{item.descricao}</Option>
                                        ))}
                                    </Select>
                                )}
                            </React.Fragment>
                        );
                    }else if(row.display == "FinalidadeRS"){
                        return (
                            <React.Fragment key={i}>
                                <div className='finalidadelist' style={{width:"96%"}}>
                                <p className='LabelGestaoRS' style={{  marginLeft:"15px" ,marginTop:"10px", marginRight:"15px", marginBottom:"0px",width: "fit-content"}}>Finalidade</p>
                                {this.state.FinalidadeRS != null && (
                                    <TreeSelect
                                        disabled={idForm != null ? true : false}
                                        showSearch
                                        className="estatoSelect GestaoListRS gestaoListFinalidade"
                                        treeData={arrayTemas}
                                        value={selectedValue} // Correção: deve ser o valor selecionado
                                        onChange={(e) => this.handleChangeFinalidade(e)} // Correção: chamada para selecionar
                                        expandedKeys={expandedKeys} // Controlando a expansão das chaves
                                        onExpand={this.onExpand} // Função para expandir ou recolher os nós
                                        placeholder="Selecione uma finalidade"
                                        style={{ width: "100% !important",  marginLeft:"15px" , marginRight:"15px" }}
                                        treeDefaultExpandAll={false} // Mantendo todos os itens fechados por padrão
                                    />
                                    //  <Select
                                    //     disabled={idForm != null ? true : false}
                                    //     showSearch
                                    //     optionFilterProp="children"
                                    //     placeholder="Selecione a finalidade"
                                    //     className="estatoSelect GestaoListRS"
                                    //     mode="single"
                                    //     onChange={(e) => this.handleChangeFinalidade(e)}
                                    //     style={{ width: "100%",  marginLeft:"15px" , marginRight:"15px" }}
                                    //     defaultValue={this.state.FinalidadeRS}
                                    // >
                                    //     <Option disabled>Selecione</Option>
                                    //     {(this.state.idFinalidadeList && !!this.state.idFinalidadeList.length) && this.state.idFinalidadeList.map((item, index) => (
                                    //         <Option key={index} value={item.idFinalidade + "-" + item.idCatFinalidade}>{item.desfinalidade}</Option>
                                    //     ))}
                                        
                                    // </Select>
                                )}
                                {this.state.FinalidadeRS == null && (
                                     <TreeSelect
                                        showSearch
                                        className="estatoSelect GestaoListRS gestaoListFinalidade"
                                        treeData={arrayTemas}
                                        value={selectedValue} // Correção: deve ser o valor selecionado
                                        onChange={(e) => this.handleChangeFinalidade(e)} // Correção: chamada para selecionar
                                        expandedKeys={expandedKeys} // Controlando a expansão das chaves
                                        onExpand={this.onExpand} // Função para expandir ou recolher os nós
                                        placeholder="Selecione uma finalidade"
                                        style={{ width: "100% !important",  marginLeft:"15px" , marginRight:"15px" }}
                                        treeDefaultExpandAll={false} // Mantendo todos os itens fechados por padrão
                                    />
                                    // <Select
                                    //     showSearch
                                    //     optionFilterProp="children"
                                    //     placeholder="Selecione a finalidade"
                                    //     className="estatoSelect GestaoListRS"
                                    //     mode="single"
                                    //     onChange={(e) => this.handleChangeFinalidade(e)}
                                    //     style={{ width: "100%",  marginLeft:"15px" , marginRight:"15px" }}
                                    //     //defaultValue={this.state.ProdutosSelecionados}
                                    // >
                                    //     <Option disabled>Selecione</Option>
                                    //     {(this.state.idFinalidadeList && !!this.state.idFinalidadeList.length) && this.state.idFinalidadeList.map((item, index) => (
                                    //         <Option key={index} value={item.idFinalidade + "-" + item.idCatFinalidade}>{item.desfinalidade}</Option>
                                    //     ))}
                                    // </Select>
                                )}
                                     </div>
                            </React.Fragment>
                        );
                    }
                    
                break;
                case "checkbox":
                    if(row.display == 'ObrigatorioCampoRS'){
                        return (
                            <div className="custom-control mt-3 ml-3 custom-checkbox">
                                <input type="checkbox" onChange={(e) => this.handleCheckObrigatorio(e)} className="custom-control-input" id={`customCheck-${i}`} name={row.key} checked={this.state.ObrigatorioCampoRS} />
                                <label className="custom-control-label" htmlFor={`customCheck-${i}`}>{Lang.langCheck.langRequest(`${row.display}`)}</label>
                            </div>
                        )
                    }else{
                        return (
                            <div className="custom-control mt-3 ml-3 custom-checkbox">
                                <input type="checkbox" onChange={(e) => this.handleCheckVisivel(e)} className="custom-control-input" id={`customCheck-${i}`} name={row.key}  checked={this.state.VisivelRS}/>
                                <label className="custom-control-label" htmlFor={`customCheck-${i}`}>{Lang.langCheck.langRequest(`${row.display}`)}</label>
                            </div>
                        )
                    }
                   
                    break;
                case "textArea":
                    return(
                        <div className="col-md-12">
                            <div className="input-box active-grey" style={{marginTop:"25px"}}>
                            <label style={{position: "absolute",zIndex: "1",top: "-12px",left: "16px",backgroundColor: "white"}} className='k-label'>Texto</label>
                                <TextArea
                                    id={row.key}
                                    name={row.key}
                                    type={row.type}
                                    style={{ width: "100%" , height: "200px",padding: "0" , paddingTop:"11px" }}
                                    className="input-1 k-textbox textareaFrases"
                                    label={"Texto"}
                                    row={50}
                                    cols={50}
                                    value={this.state ? this.state.descricao : ""}
                                    onChange={(e) => this.handleChangeTexto(e)}
                                />
                                
                            </div>
                        </div>
                    )
                break;
                default:
                    if(row.display == 'NomeCampoRS'){
                        return (
                            <div className="col-md-12">
                                <div className="input-box active-grey" style={{marginBottom:0}}>
                                    <Input
                                        id={row.key}
                                        name={row.key}
                                        type={row.type}
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        label={Lang.langCheck.langRequest(`${row.display}`)}
                                        value={this.state ? this.state.NomeCampoRS : ""}
                                        onChange={(e) => this.handleChangeNomeCampoRS(e)}
                                    />
                                </div>
                            </div>
                        )
                    }else if(row.display == 'OrdemRS'){
                        return (
                            <div className="col-md-12">
                                <div className="input-box active-grey" style={{marginBottom:0}}>
                                    <Input
                                        id={row.key}
                                        name={row.key}
                                        type={row.type}
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        label={Lang.langCheck.langRequest(`${row.display}`)}
                                        value={this.state ? this.state.OrdemRS : ""}
                                        onChange={(e) => this.handleChangeOrdemRS(e)}
                                    />
                                </div>
                            </div>
                        )
                    }
            }
        });
        return inputs
    }

    handleSelect = (value) => {
        try {
            this.setState({
                codEstatuto: value
            })
        } catch (error) {
            this.setState({error})
        }
    }

    handleEntitySelect = (value) => {
        try {
            this.setState({
                codEntidade: +value
            })
        } catch (error) {
            this.setState({error})
        }
    }

    createInputFields = () => {
        try {
            let InputFieldsdivs = Object.keys(InputFieldsAll).map((nevkey) => {
                return (<div className="bg-white middle p20" id={nevkey}>
                    <div className="head" style={{marginBottom: "1px"}}>
                        <h2> {Lang.langCheck.langRequest(`${nevkey}`)}</h2>
                       
                    </div>
                    <div className="row">
                        {this.createInputs(nevkey)}
                    </div>
                </div>
                )
            });
    
            return InputFieldsdivs;
        } catch (error) {
            this.setState({error})
        }
    }

    getEntidadeById = async (id) => {
        try {
            let parsed = queryString.parse(window.location.search)
            if(parsed.id){
                var data = {IDFormularioEncrypt: parsed.id}
            }else{
                var data = {IDFormularioEncrypt: "0"}
            }

            let _user = await services.apiCall.requestApi(
                "/RequisicaoServicos/GetCampoById",
                data,
                "get"
            );
            if (_user) {
                
                if (_user.length> 0) {
                    this.setState({
                        FinalidadeRS: _user[0].idFinalidade + "-" + _user[0].idCatFinalidade,
                        ObrigatorioCampoRS: _user[0].obrigatorio,
                        VisivelRS : _user[0].visivel,
                        OrdemRS: _user[0].ordem,
                        ProdutosSelecionados: _user[0].codEtapa,
                        idCamposFormulario: _user[0].idCamposFormulario,
                       NomeCampoRS: _user[0].idCamposFormulario,
                    })
                }
            }  
        } catch (error) {
            this.setState({error})
        }
    }

    handleSubmit = (e, backUrl) => {
        e.preventDefault();
        try {
            let parsed = queryString.parse(window.location.search)
                if(parsed.id != undefined && parsed.id != null){
                // é o update
                    this.handleUpdateCampo(parsed.id, backUrl);
                } else {
                    // adiciona novo
                    this.handleAddCampo(null,backUrl);
                }
            
        } catch (error) {
            this.setState({error})
        }
    }

    handleUpdateCampo = async (id, backUrl) => {
        try {
            if(id){
                let parsed = queryString.parse(window.location.search)

                var data = {
                    idFormulario: id,
                    idFinalidade: this.state.FinalidadeRS.split("-")[0],
                    idCatFinalidade: this.state.idCatFinalidade,
                    idCamposFormulario: this.state.NomeCampoRS,
                    obrigatorio: this.state.ObrigatorioCampoRS,
                    visivel : this.state.VisivelRS,
                    ordem: this.state.OrdemRS,
                    etapa: this.state.ProdutosSelecionados,
                    LoggedUser:  window.localStorage.getItem('username'),
                }

                console.log(data, "DATAAAAAAAA")
                var res = await services.apiCall.requestApi(`/RequisicaoServicos/UpdateandCreateFieldsRS`, data, 'post')
                if (res) {
                    if (backUrl) {
                        this.props.history.push({
                            pathname: backUrl,
                            state:{topBarMenu : this.props.topBarMenuOption}
                        })
                    }
                }
            
            }
            
        } catch (error) {
            this.setState({error})
        }
    }

    handleAddCampo = async (id, backUrl) => {
        try {
                var data = {
                    idFormulario: null,
                    idFinalidade: this.state.FinalidadeRS.split("-")[0],
                    idCatFinalidade: this.state.idCatFinalidade,
                    idCamposFormulario: this.state.NomeCampoRS,
                    obrigatorio: this.state.ObrigatorioCampoRS,
                    visivel : this.state.VisivelRS,
                    ordem: this.state.OrdemRS,
                    etapa: this.state.ProdutosSelecionados,
                    LoggedUser:  window.localStorage.getItem('username'),
                }

                console.log(this.state, "DATAAAAAAAA")
                var res = await services.apiCall.requestApi(`/RequisicaoServicos/UpdateandCreateFieldsRS`, data, 'post')
                if (res) {
                    if (backUrl) {
                        this.props.history.push({
                            pathname: backUrl,
                            state:{topBarMenu : this.props.topBarMenuOption}
                        })
                    }
                }
            
            
        } catch (error) {
            this.setState({error})
        }
    }

    checkRequestData = () => {
        if(this.state.codEntidade == 0 || this.state.codEstatuto.length == 0){
            return false
        }else{
            return true
        }
    }

    handleCreateEntityEstatutoList = async (backUrl) => {
        try {
            let data = {
                codEntidade: this.state.codEntidade,
                codEstatuto: this.state.codEstatuto,
            }
            let res ;
            let {isChecked} = this.state;
            if(isChecked || !backUrl){
            res= await services.apiCall.requestApi('/BusEntidadeEstatuto/Create', data, 'post')
            }
            if (res) {
                this.setState({
                    isChecked: false,
                })
               
            }
            if (backUrl ) {
                this.props.history.push({
                    pathname: '/entity_rule_list',
                    state:{topBarMenu : this.props.topBarMenuOption}
                })
            }
        } catch (error) {
            this.setState({error})
        }

    }

    render() {
        console.log("state",this.state)
        console.log("props",this.props)
        if(this.state.error){
            throw this.state.error
        }
        return (
            <div className="dashboard">
                {
                    
                    // (this.props.id && this.props.id.location && this.props.id.location.state && this.props.id.location.state.entidade_id) ?
                        this.state.id ?
                        <FormNavbar to={'/admin_dashboard_gestaors'} topBarMenu={this.props.topBarMenuOption} handleSubmit={(e, url) => this.handleSubmit(e, url)} type='auditing' headName="Editar campo RS" />
                        :
                        <FormNavbar to={'/admin_dashboard_gestaors'} topBarMenu={this.props.topBarMenuOption} handleSubmit={(e, url) => this.handleSubmit(e, url)} type='auditing' headName="Criar novo campo RS" />
                }
                <div className="full-container edit-ward">
                    <FormleftNev InputFieldsAll={InputFieldsAll} />
                    <div className="right-section">

                        <div className="row top-serch">
                            {
                                this.createInputFields()
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default withRouter(NovosCamposRS);